import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SalesChart = () => {
  const [chartType, setChartType] = useState('bar');
  const [timeRange, setTimeRange] = useState('7days');

  const salesData = [
    { name: 'Mon', sales: 4200, orders: 12 },
    { name: 'Tue', sales: 3800, orders: 10 },
    { name: 'Wed', sales: 5200, orders: 15 },
    { name: 'Thu', sales: 4600, orders: 13 },
    { name: 'Fri', sales: 6800, orders: 18 },
    { name: 'Sat', sales: 7200, orders: 20 },
    { name: 'Sun', sales: 5400, orders: 16 }
  ];

  const monthlyData = [
    { name: 'Jan', sales: 45000, orders: 120 },
    { name: 'Feb', sales: 52000, orders: 140 },
    { name: 'Mar', sales: 48000, orders: 130 },
    { name: 'Apr', sales: 61000, orders: 165 },
    { name: 'May', sales: 55000, orders: 150 },
    { name: 'Jun', sales: 67000, orders: 180 }
  ];

  const currentData = timeRange === '7days' ? salesData : monthlyData;

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-border rounded-md shadow-elevation-2">
          <p className="text-sm font-medium text-foreground">{label}</p>
          <p className="text-sm text-primary">
            Sales: ${payload[0].value.toLocaleString()}
          </p>
          <p className="text-sm text-accent">
            Orders: {payload[0].payload.orders}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg border border-border shadow-elevation-1 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Sales Overview</h3>
        
        <div className="flex items-center space-x-2">
          <div className="flex bg-muted rounded-md p-1">
            <Button
              variant={timeRange === '7days' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setTimeRange('7days')}
              className="text-xs"
            >
              7 Days
            </Button>
            <Button
              variant={timeRange === '6months' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setTimeRange('6months')}
              className="text-xs"
            >
              6 Months
            </Button>
          </div>
          
          <div className="flex bg-muted rounded-md p-1">
            <Button
              variant={chartType === 'bar' ? 'default' : 'ghost'}
              size="icon"
              onClick={() => setChartType('bar')}
              className="w-8 h-8"
            >
              <Icon name="BarChart3" size={14} />
            </Button>
            <Button
              variant={chartType === 'line' ? 'default' : 'ghost'}
              size="icon"
              onClick={() => setChartType('line')}
              className="w-8 h-8"
            >
              <Icon name="TrendingUp" size={14} />
            </Button>
          </div>
        </div>
      </div>

      <div className="w-full h-80" aria-label="Sales Overview Chart">
        <ResponsiveContainer width="100%" height="100%">
          {chartType === 'bar' ? (
            <BarChart data={currentData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
              <XAxis 
                dataKey="name" 
                stroke="#475569"
                fontSize={12}
              />
              <YAxis 
                stroke="#475569"
                fontSize={12}
                tickFormatter={(value) => `$${value.toLocaleString()}`}
              />
              <Tooltip content={<CustomTooltip />} />
              <Bar 
                dataKey="sales" 
                fill="#2563EB"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          ) : (
            <LineChart data={currentData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
              <XAxis 
                dataKey="name" 
                stroke="#475569"
                fontSize={12}
              />
              <YAxis 
                stroke="#475569"
                fontSize={12}
                tickFormatter={(value) => `$${value.toLocaleString()}`}
              />
              <Tooltip content={<CustomTooltip />} />
              <Line 
                type="monotone" 
                dataKey="sales" 
                stroke="#2563EB"
                strokeWidth={3}
                dot={{ fill: '#2563EB', strokeWidth: 2, r: 4 }}
                activeDot={{ r: 6, stroke: '#2563EB', strokeWidth: 2 }}
              />
            </LineChart>
          )}
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SalesChart;